import React from 'react';
import { Routes, Route } from 'react-router-dom';

// Start Main 
import Header from './components/main/Header';
import Footer from './components/main/Footer';

// Start Pages
import Home from './components/pages/Home';
import AboutUs from './components/pages/AboutUs';
import Brands from './components/pages/Brands';
import Collections from './components/pages/Collections';
import ContactUs from './components/pages/ContactUs';

// Start Hooks
import Top from './components/Top';
import ScrollToTop from './components/ScrollToTop';
import UseScrollAnimation from './hooks/UseScrollAnimation';

const App = () => {
    return (
        <>
            <Header />
            <Top />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<AboutUs />} />
                <Route path="/brands" element={<Brands />} />
                <Route path="/collections" element={<Collections />} />
                <Route path="/contact" element={<ContactUs />} />
            </Routes>
            <Footer />

            <ScrollToTop />
            <UseScrollAnimation />

        </>
    );
};

export default App;
